import React, { useState } from "react";
import ConversationInbox from "./ConversationInbox";
import ConversationThread from "./ConversationThread";

const ConversationsTab = ({ admins }) => {
    const [selectedId, setSelectedId] = useState(null);

    const handleOpen = (id) => setSelectedId(id);
    const handleBack = () => setSelectedId(null);

    if (selectedId) {
        return (
            <ConversationThread
                conversationId={selectedId}
                admins={admins}
                onBack={handleBack}
            />
        );
    }

    return <ConversationInbox onOpen={handleOpen} admins={admins} />;
};

export default ConversationsTab;
